export { ViewCommentShortcutListener } from '../src/ViewCommentShortcutListener';
